<template>
  <v-dialog
    v-model="dialog"
    width="700"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="indigo"
        text
        v-on="on"
      >
        Помощь
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="headline amber lighten-1"
        primary-title
      >
        Помощь
      </v-card-title>
      <v-card-text class="pb-0">
        <v-card flat>
          <v-card-title class="subtitle-2 pb-1">Проблема с восстановлением доступа</v-card-title>
          <v-card-text class="pb-0">
            Если Вы верно вводите свои данные, но у Вас возникают какие-либо ошибки, Вам не приходит письмо на электронную почту
            или Вы не понимаете, что нужно вводить, свяжитесь с поддержкой приемной комиссии КузГТУ любым
            доступным Вам способом из указанных ниже.<br>
            Будьте готовы сообщить оператору данные своего документа, удостоверяющего личность.
          </v-card-text>
        </v-card>
        <contact-card></contact-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ContactCard from "./ContactCard";
  export default {
    name: "HelpPasswordRecovery",
    components: {ContactCard},
    data() {
      return {
        dialog: false,
      }
    },
  }
</script>

<style scoped>
  .v-list-item__title,
  .v-list-item__subtitle {
    white-space: normal;
  }
</style>
